import React, { Component } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LessonGrandchildWorkspace from '~/components/courses/lesson-grandchild-workspace';
import NodeHeader from '~/components/common/node-header';
import { toggleExpandEntity } from '~/redux/actions/workspaceActions';

/**
 * Lesson Child component for the workspace. It can contain either topics or quizzes.
 */
class LessonChildWorkspace extends Component {
	/**
	 * Constructor
	 *
	 * @param {Object} props
	 */
	constructor( props ) {
		super( props );

		/**
		 * State
		 */
		this.state = {
			expanded: this.props.node.expanded,
			isDropDisabled: true,
			isDragDisabled: false,
			workspace: this.props.workspace.present,
		};
	}

	/**
	 * Checks whether we want to toggle all the nodes and whether a draggable can be droppable.
	 *
	 * @param {Object} props
	 * @param {Object} state
	 */
	static getDerivedStateFromProps( props, state ) {
		const workspace = props.workspace.present;
		const prevWorkspace = state.workspace;
		const stateObject = {
			workspace,
		};
		let isDropDisabled = true;
		let isDragDisabled = false;

		// Listen to any change to the expand all/collapse all button in the header
		if ( workspace.expandAll !== prevWorkspace.expandAll ) {
			stateObject.expanded = workspace.expandAll;
		}

		if (
			workspace.currentDraggableEntity !== state.currentDraggableEntity &&
			workspace.currentDraggableEntity
		) {
			if (
				'quiz' === workspace.currentDraggableEntity.type ||
				'sfwd-quiz' === workspace.currentDraggableEntity.type
			) {
				isDropDisabled = false;
			}

			if (
				'quiz' === workspace.currentDraggableEntity.type ||
				'sfwd-quiz' === workspace.currentDraggableEntity.type
			) {
				if (
					'topic' === props.node.type ||
					'sfwd-topic' === props.node.type
				) {
					isDragDisabled = true;
				}
			} else if (
				'topic' === workspace.currentDraggableEntity.type ||
				'sfwd-topic' === workspace.currentDraggableEntity.type
			) {
				if (
					'quiz' === props.node.type ||
					'sfwd-quiz' === props.node.type
				) {
					isDragDisabled = true;
				}
			}
		}

		stateObject.isDropDisabled = isDropDisabled;
		stateObject.isDragDisabled = isDragDisabled;

		return stateObject;
	}

	/**
	 * Render function
	 */
	render() {
		const { node, indexLesson, index, toggleExpandEntity } = this.props;
		return (
			<Draggable
				draggableId={ JSON.stringify( { ...node } ) }
				index={ indexLesson }
				key={ node.ID }
			>
				{ ( provided ) => (
					<div
						key={ node.ID }
						ref={ provided.innerRef }
						{ ...provided.draggableProps }
						className={ classNames( {
							'ld__builder--child-item': true,
							'-disable-sort': this.state.isDragDisabled,
						} ) }
					>
						<NodeHeader
							node={ node }
							provided={ provided }
							expanded={ this.state.expanded }
							className={ classNames( {
								'ld__builder-row-type': true,
								'-child': true,
							} ) }
							indexLesson={ indexLesson }
							index={ index }
							toggleNode={ ( e ) => {
								e.preventDefault();
								toggleExpandEntity( index, node );
								this.setState( ( { expanded } ) => ( {
									expanded: ! expanded,
								} ) );
							} }
						/>

						{ /* Topics can have quizzes */ }
						{ ( 'topic' === node.type ||
							'sfwd-topic' === node.type ) &&
							this.state.expanded && (
								<Droppable
									droppableId={ JSON.stringify( {
										ID: node.ID,
										type: 'topic-quiz',
									} ) }
									key={ node.ID }
									isDropDisabled={ this.state.isDropDisabled }
								>
									{ (
										nodeDropProvided,
										nodeDropSnapshot
									) => (
										<div
											ref={ nodeDropProvided.innerRef }
											className={ classNames( {
												'ld__builder--grandchild': true,
												'-is-dragging-over':
													nodeDropSnapshot.isDraggingOver,
											} ) }
										>
											{ node.tree.map(
												( lastNode, index ) => (
													<LessonGrandchildWorkspace
														node={ lastNode }
														key={ lastNode.ID }
														index={ index }
														indexLesson={
															indexLesson
														}
													/>
												)
											) }

											{ /* Placeholder for dropping new quizzes */ }
											<div
												className="ld__builder--placeholder"
												data-label={ `${ LearnDashData.i18n.drop_quizzes }` }
											>
												{ nodeDropProvided.placeholder }
											</div>
										</div>
									) }
								</Droppable>
							) }
					</div>
				) }
			</Draggable>
		);
	}
}

/**
 * Valid props
 */
LessonChildWorkspace.propTypes = {
	node: PropTypes.object,
	indexLesson: PropTypes.number,
	index: PropTypes.number,
	toggleExpandEntity: PropTypes.func,
	workspace: PropTypes.shape( {
		present: PropTypes.object,
	} ),
	data: PropTypes.shape( {
		labels: PropTypes.object,
	} ),
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => ( {
	...state,
} );

/**
 *
 * @param {*} dispatch
 */
const mapDispatchToProps = ( dispatch ) => ( {
	toggleExpandEntity: ( indexLesson, node ) =>
		dispatch( toggleExpandEntity( indexLesson, node ) ),
} );

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( LessonChildWorkspace );
